import React, { useEffect, useRef, useState } from "react";
import Img from "./Img";

export default function Reveal({ children, delay = 0, className = "", as: Tag = "div" }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setVisible(true);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      suppressHydrationWarning
      className={`reveal ${visible ? "is-visible" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </Tag>
  );
}

export function SectionTitle({ kicker, title, light = false, align = "center", tag: Tag = "h2" }) {
  const delim = light
    ? "/images/2017_01_delim_white.webp"
    : "/images/2017_01_delim_small.webp";
  return (
    <div className={align === "center" ? "text-center" : "text-left"}>
      {kicker && (
        <p
          className="ah-kicker mb-1"
          style={{ color: light ? "rgba(255,255,255,0.92)" : "#148456" }}
        >
          {kicker}
        </p>
      )}
      <Tag
        className="ah-heading text-[26px] leading-snug sm:text-[30px] md:text-[34px]"
        style={{ color: light ? "#ffffff" : "#383838" }}
      >
        {title}
      </Tag>
      <Img
        src={delim}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className={`mt-5 h-[14px] w-auto ${align === "center" ? "mx-auto" : ""}`}
      />
    </div>
  );
}
